
<template>
	<c-dialog ref="dialog" width="500" height="200" @resolve="editHandle">
		<c-form ref="workForm" unit-width="100%">
			<c-form-item label="设置为" required>
				<c-select name="priority" :options="prioritySelectDic"></c-select>
			</c-form-item>
			<c-form-item :label="false">
				<c-checkbox-group name="isSyncTask" >
				    <c-checkbox value="1">同步更新至任务</c-checkbox>
				</c-checkbox-group>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	computed: {
		// 获取dictName选项数据
		...mapState(['prioritySelectDic'])
	},
	data() {
		return {
			work_id: 0,
			work_ids: []
		}
	},
	
	// 监听器
	watch: {
		
	},
	
	methods: {
		/************打开新增、编辑弹窗**************/
		open(data) {
			this.$refs.workForm.clear();
			this.work_id = data.id;
			this.work_ids = [];
			this.getDetail();
			this.$refs.dialog.open({
				title: '工单优先级'
			});
		},
		
		/************打开批量编辑弹窗**************/
		batchOpen(ids) {
			this.$refs.workForm.clear();
			this.work_id = 0;
			this.work_ids = ids;
			this.$refs.dialog.open({
				title: '批量调整工单优先级'
			});
		},

		/*******搜索工单详情*******************/
		getDetail() {
			this.request({
				url:'/work/detail',
				data: {
					id: this.work_id
				},
				loading: true,
				success: data => {
					//工单基本信息
					this.$refs.workForm.set(data.detailInfo);
				}
			});
		},
		
		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			this.$refs.workForm.submit({
				url: this.work_ids.length == 0?'/work/editPriority':'/work/editPriority/batch',
				rule: {
					priority: '请选择优先级'
				},
			    dataFormatter: data => {
					data.id = this.work_id||0;
					data.ids = this.work_ids;
					data.isSyncTask = data.isSyncTask.length;
					return data;
				},
				success: (data, res) => {
					next();
					let Mtype = 'success';
					let message = '调整优先级成功';
					if(this.work_ids.length > 0){
						message = '成功' + res.success_count + '条';
						if(res.fail_count > 0 && res.success_count > 0){
							Mtype = 'warn';
							message += '，失败'+res.fail_count+'条';
						}else if(res.fail_count > 0 && res.success_count == 0){
							Mtype = 'fail'
							message += '，失败'+res.fail_count+'条';
						}else{
							message = '成功调整优先级' + res.success_count + '条';
						}
					}
					this.$message({
						message: message,  // 提示内容,
						type: Mtype
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>